export const extractApiErrors = (error) => {
  const payload = error?.response?.data;
  const apiErrors = payload?.errors;
  const fieldErrors = {};
  const messageParts = [];

  if (Array.isArray(apiErrors)) {
    messageParts.push(...apiErrors.filter(Boolean));
  } else if (apiErrors && typeof apiErrors === 'object') {
    Object.entries(apiErrors).forEach(([field, messages]) => {
      const normalized = Array.isArray(messages) ? messages : [messages];
      fieldErrors[field] = normalized;
      messageParts.push(...normalized.filter(Boolean));
    });
  }

  if (typeof payload?.error === 'string') messageParts.push(payload.error);
  if (typeof payload?.message === 'string') messageParts.push(payload.message);

  const unique = Array.from(
    new Set(messageParts.map((part) => part.toString().trim()).filter(Boolean))
  );

  return {
    fieldErrors,
    message: unique.length > 0 ? unique.join(' ') : 'An unexpected error occurred.',
    status: error?.response?.status,
  };
};
